import { call } from './utils';

export const confirmRentPayment = async (data, accessToken) =>
  await call({
    url: '/api/payment/confirm/payment',
    data: { data },
    token: accessToken
  });
